import * as Sentry from '@sentry/react';
import { SENTRY_DSN, SENTRY_ENVIRONMENT } from './config';

const appVersion = `${import.meta.env.VITE_APP_VERSION}`;
console.log('App Version:', appVersion);

Sentry.init({
    dsn: SENTRY_DSN,
    release: `safepoint-portal@${appVersion}`,
    environment: SENTRY_ENVIRONMENT,
    tracesSampleRate: 1.0
});
